import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import AddContract from './add'
import EditContract from './edit'
import { TableComp } from 'sz-react-utils-lite'
import {
  contractWith,
  displayDate, filterOption, DefaultTablePagination
} from '../../../components/_utils/appUtils'
import { getContractGroups, listAllContract, updateContractStatusFxn } from '../actions/contract'
import { Button, Col, Icon, Input, Modal, notification, Row, Select, Tooltip } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { AllowComponentRightsWise } from '../../WebComponent/allowComponentRightsWise'
import { listAllCountries } from '../../countries/actions/countries'
import { getUrlPushWrapper } from '../../../routes/routes'
import { updateInstituteEventStatusFxn } from '../../institutes/action'

const { Option } = Select
const universityTypeList = [
  { name: 'Already Added in Portal', value: 'alreadyAdded' },
  { name: 'Not Added in Portal', value: 'other' }
]

const ContractList = (props) => {
  const tableRef = useRef()
  const dispatch = useDispatch()
  let [totalRecord, setTotalRecord] = useState(0)
  const [itemNo, setItemNo] = useState(1)
  const [addContractVisible, setAddContractVisible] = useState(false)
  const [editContractVisible, setEditContractVisible] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [contractId, setContractId] = useState('')
  const [contractWith, setContractWith] = useState([])
  const [contractFilter, setContractFilter] = useState([])
  const [countryList, setCountryList] = useState([])
  const [countryId, setCountryId] = useState()
  const [contractStatus, setContractStatus] = useState()
  const [contractType, setContractType] = useState()
  const [region, setRegion] = useState()
  const [commissionStructure, setCommissionStructure] = useState()
  const [cancelReason, setCancelReason] = useState('')

  const [status, setStatus] = useState()

  const [groupData, setGroupData] = useState([])


  const events = {
    hideDrawer: () => {
      setAddContractVisible(false)
      tableRef.current.reload()
    },
    hideEditDrawer: () => {
      setEditContractVisible(false)
      tableRef.current.reload()
    }

  }

  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let extraFilters = {}
      if (countryId) extraFilters.countryId = countryId
      if (contractType) extraFilters.contractType = contractType
      if (region) extraFilters.applicableRegions = region
      if (commissionStructure) extraFilters.commissionStructure = commissionStructure

      if (Array.isArray(contractFilter) && contractFilter.length) {
        extraFilters.contractFilterArr = contractFilter
      }
      params.sortField = '_id'
      params.sortOrder = 'descend'
      const finalParams = { ...params, ...extraFilters, status: contractStatus }

      const respData = await dispatch(listAllContract(finalParams))

      setTotalRecord(respData.total || 0)
      resolve(respData)
    })
  }


  const getContractWithGroups = async (params = {}) => {
    let respData = await dispatch(getContractGroups({
      ...params
    }))
    let { contractWith } = respData
    setContractWith(contractWith)
    let cloneDoc = _.clone(contractWith)
    _.each(cloneDoc, (item) => {
      let findVal = _.find(respData.data, (doc) => {
        return doc._id == item.name
      })
      if (findVal) {
        item.value = findVal.count
      }
    })
    setGroupData(cloneDoc)
  }

  useEffect(() => {
    getContractWithGroups()
    loadCountryList()
  }, [])


  const handleDownload = (item) => {
    const anchor = document.createElement('a')
    anchor.href = item.path
    anchor.download = item.fileName
    anchor.target = '_blank'
    anchor.click()
  }

  const handleContractFilter = (item) => {
    setContractFilter([item])
    setTimeout(() => {
      tableRef.current.reload()
    }, 100)
  }

  const loadCountryList = async () => {
    let params = {
      results: 5000,
      select: ['countryName'],
      sortField: 'countryName',
      sortOrder: 'ascend'
    }
    let { data } = await dispatch(listAllCountries(params))
    if (data && data.length) {
      setCountryList(data)
    }
  }
  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      width: 50,
      key: 'sno',
      render: (item, record, index) => (
        <a className={'linkPointer'}>
          {(itemNo - 1) * 10 + index + 1}
        </a>
      )
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 120,
      render: (item, record) => {
        let { endDate } = record
        let noOfDays = moment(endDate).diff(moment(), 'days')
        return (
          <div className={'alignCenter'}>
            {noOfDays <= 15 && noOfDays > 0 && (
              <label className={'label label-warning label-sm'}>
                Expiring in {noOfDays} {noOfDays === 1 ? 'Day' : 'Days'}
              </label>
            )}
            {noOfDays > 15 && (
              <label className={'label label-success label-sm'}>Active</label>
            )}
            {noOfDays <= 0 && (
              <label className={'label label-danger label-sm'}>Expired</label>
            )}
          </div>
        )
      }
    },
    {
      title: 'Contract With',
      key: 'contractWith',
      dataIndex: 'contractWith',
      width: 170
    },
    {
      title: 'Country',
      dataIndex: 'countryId',
      key: 'countryId',
      width: 150,
      render: (item) => item && item.countryName || ''
    },
    {
      title: 'Institute',
      dataIndex: 'institutionType',
      key: 'institutionType',
      width: 150,
      render: (item) => {
        return (
          <>
            {item}
          </>
        )
      }
    },

    {
      title: 'University/College/School/Pathway',
      dataIndex: 'universityType',
      key: 'universityType',
      width: 150,
      render: (item, record) => {
        let { universityId, universityName } = record
        return (
          <>
            {item === 'alreadyAdded' && universityId && universityId.universityName}
            {item === 'other' && universityName}
          </>
        )
      }
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      width: 120,
      render: (item) => item ? displayDate(item) : ''
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      width: 120,
      render: (item) => item ? displayDate(item) : ''
    },
    {
      title: 'Contract',
      dataIndex: 'contract',
      key: 'contract',
      width: 150,
      render: (item) => (
        <a className={'btn btn-link btn-xs'} onClick={() => handleDownload(item)}>
          Download
        </a>
      )
    },
    {
      title: 'Details',
      key: 'details',
      dataIndex: 'details'
    },
    {
      title: 'Representative',
      key: 'representative',
      width: 200,
      render: (_, record) => {
        const { representativeName, repContactNumber, repEmailId } = record || {}
        return (
          <div style={{ fontSize: 12 }}>
            {(representativeName || '')}<br />
            {(repContactNumber || '')}<br />
            {(repEmailId || '')}
          </div>
        )
      }
    },
    {
      title: 'Registered',
      key: 'registered',
      width: 200,
      render: (_, record) => {
        const { registeredNumber, registeredEmailId } = record || {}
        return (
          <div style={{ fontSize: 12 }}>
            {(registeredNumber || '')}<br />
            {(registeredEmailId || '')}
          </div>
        )
      }
    },
    {
      title: 'Additional Contact',
      key: 'additionalContact',
      width: 200,
      render: (_, record) => {
        const { additionalContactName, additionalContactNumber, additionalContactEmail } = record || {}
        return (
          <div style={{ fontSize: 12 }}>
            {(additionalContactName || '')}<br />
            {(additionalContactNumber || '')}<br />
            {(additionalContactEmail || '')}
          </div>
        )
      }
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      width: 80,
      fixed: 'right',
      render: (_, record) => (
        <>
          <Tooltip title='Update Contract'>
            <a
              className={'btn btn-default roundNew aic jcc sm'}
              onClick={() => {
                setEditContractVisible(true)
                setContractId(record._id)
              }}
            >
              <Icon type='edit' /> Edit
            </a>
          </Tooltip>
          <Tooltip title='Delete Contract'>
            <a
              className={'btn btn-default roundNew aic jcc sm'}
              onClick={() => {
                setDeleteModalVisible(true)
                setContractId(record._id)
              }}
            >
              <Icon type='delete'  style={{ color: 'red' }}  />  Delete
            </a>
          </Tooltip>
        </>


      )
    }
  ]


  const getParamsForApplicationList = () => {
    return new Promise(resolve => {
      let searchParams = new URLSearchParams(window.location.search)
      let countryId = searchParams.get('countryId')
      let status = searchParams.get('status')
      let obj = {}
      if (countryId) {
        obj.countryId = countryId
      }

      resolve(obj)
    })
  }


  const searchFxn = () => {
    if (tableRef && tableRef.current) {
      tableRef.current.reload()
    }
  }


  const clearFxn = () => {
    setCountryId(undefined)
    setContractStatus(undefined)
    setContractType(undefined)
    setRegion(undefined)
    setCommissionStructure(undefined)
    setContractFilter([])
    setSelectedGroup(null)

    setTimeout(() => {
      if (tableRef && tableRef.current) {
        tableRef.current.reload()
      }
    }, 100)
  }


  const [selectedGroup, setSelectedGroup] = useState(null)

  const GroupingTags = (
    <>
      <div className={'reportBox'} style={{ marginTop: 0 }}>
        <div className={'custom_row'}>
          {groupData.map((item, key) => {
            return (
              <div
                key={key}
                className={'custom_col'}
                onClick={() => {
                  setSelectedGroup(item.name)
                  handleContractFilter(item.name)
                }}
              >
                <div
                  className={'reportingBox'}
                  style={{
                    outline: selectedGroup === item.name ? '2px solid #007bff' : 'none',
                    outlineOffset: '0px'
                  }}
                >
                  <div className={'reportingInnerBox'}>
                    <img src={'../assets/userIcon.png'} alt={'No image'} />
                    <div className={'reportInfoBox'}>
                      {item.name} ({item.value})
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
  const filterBlock = (
    <Row gutter={16}>
      {/* Country */}
      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            name='Search By Country'
            onChange={item => setCountryId(item)}
            filterOption={filterOption}
            className='antSelect'
            placeholder='Country'
            allowClear
            showSearch
            value={countryId || undefined}>
            {countryList.map((item, key) => (
              <Option value={item._id} key={key}>
                {item.countryName}
              </Option>
            ))}
          </Select>
        </div>
      </Col>

      {/* Contract Status */}
      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            placeholder='Contract Status'
            allowClear
            value={contractStatus || undefined}
            onChange={val => setContractStatus(val)}
            className='antSelect'>
            <Option value='Active'>Active</Option>
            <Option value='Expiring'>Expiring</Option>
            <Option value='Expired'>Expired</Option>
          </Select>

        </div>
      </Col>

      {/* Contract Type */}
      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            placeholder='Contract Type'
            allowClear
            value={contractType || undefined}
            onChange={val => setContractType(val)}
            className='antSelect'>
            {['Direct', 'Third Party', 'Exclusive', 'Other', 'All'].map(type => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </div>
      </Col>

      {/* Region */}
      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            placeholder='Region'
            allowClear
            value={region || undefined}
            onChange={val => setRegion(val)}
            className='antSelect'>
            {['Global', 'South Asia', 'India', 'Global Ex India', 'Other', 'All'].map(region => (
              <Option key={region} value={region}>
                {region}
              </Option>
            ))}
          </Select>
        </div>
      </Col>

      {/* Commission Structure */}
      <Col md={4} sm={4} xs={8} lg={4}>
        <div className='sort-box-table custom-sort-box-new'>
          <Select
            placeholder='Commission'
            allowClear
            value={commissionStructure || undefined}
            onChange={val => setCommissionStructure(val)}
            className='antSelect'>
            {['Slab %', 'Fixed', 'Other', 'All'].map(comm => (
              <Option key={comm} value={comm}>
                {comm}
              </Option>
            ))}
          </Select>
        </div>
      </Col>


      <Col md={4} sm={4} xs={8} lg={4}>
        <Button onClick={searchFxn} className='roundBtn'>
          Search
        </Button>
        <Button onClick={clearFxn} className='roundBtn'>
          Clear
        </Button>
      </Col>
    </Row>
  )
  const handleCancelSubmit = async (contractId, reason) => {
    if (!cancelReason) {
      notification.warning({ message: 'Please enter valid reason' })
      return
    }
    let resp = await dispatch(updateContractStatusFxn(contractId, reason))
    if(resp.success){
      tableRef.current.reload()
      getContractWithGroups()
      setContractId('')
      setCancelReason('')
      setDeleteModalVisible(false)
    }


  }

  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card reportContainer'>
          <div className='table-head d-flex align-items-center'>
            <h5>All Contract: ({totalRecord})</h5>
            <div className='search-box-table'>
            </div>
            <div className='sort-box-table mark-btn'>
              <button
                className='btn'
                onClick={() => setAddContractVisible(true)}
              >
                <img src={'../dist/icons/plus.png'} className={'plus'} />
                Add Contract
              </button>
            </div>
          </div>
          <div className='card-body table-responsive'>
            {GroupingTags}
            {filterBlock}
            <TableComp columns={columns}
                       apiRequest={apiRequest}
                       ref={tableRef}
                       pagination={DefaultTablePagination()}
            />
          </div>
        </div>
      </div>
      {addContractVisible ?
        <AddContract
          visible={addContractVisible}
          universityTypeList={universityTypeList}
          contractWith={contractWith}
          events={events}
        /> : ''}
      {editContractVisible ?
        <EditContract
          visible={editContractVisible}
          universityTypeList={universityTypeList}
          contractWith={contractWith}
          events={events}
          id={contractId}
        /> : ''}
      {deleteModalVisible ? <Modal
        title='Delete Contract'
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key='submit' type='primary' onClick={() => handleCancelSubmit(contractId, cancelReason)}>
            Submit
          </Button>
        ]}>
        <Input.TextArea
          placeholder='Enter reason'
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          autoSize={{ minRows: 3, maxRows: 6 }}
        />
      </Modal> : null}
    </div>
  )
}
export default ContractList
